import { Directive, effect, input, signal } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[mweCollapse]',
  exportAs: 'mweCollapse',
})
export class Collapse extends NgbCollapse {
  mweCollapse = input<boolean>(true);
  isClosed = signal<boolean>(true);
  constructor() {
    super();
    effect(() => {
      this.isClosed.set(this.mweCollapse());
      this.collapsed = this.mweCollapse();
    });
  }

  override toggle(open: boolean = this.isClosed()) {
    this.collapsed = !open;
    this.isClosed.update(current => !current);
    this.ngbCollapseChange.next(this.isClosed());
  }
}
